import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { createTheme, ThemeProvider, useTheme } from '@material-ui/core/styles';
import { CHERRY_DEV } from './cherryDevBrand';

/**
 * Tema local cherryDev encima del tema global TNO (solo esta landing/CRM).
 */
export function buildCherryDevTheme(baseTheme) {
  return createTheme(baseTheme, {
    palette: {
      primary: {
        main: CHERRY_DEV.cherry,
        dark: CHERRY_DEV.cherryDark,
        light: CHERRY_DEV.cherryLight,
        contrastText: CHERRY_DEV.white,
      },
      secondary: {
        main: CHERRY_DEV.leaf,
        dark: CHERRY_DEV.leafDark,
        light: CHERRY_DEV.leafLight,
        contrastText: CHERRY_DEV.white,
      },
      background: {
        paper: CHERRY_DEV.cream,
        default: CHERRY_DEV.blush,
      },
      alternate: {
        main: CHERRY_DEV.blush,
        dark: CHERRY_DEV.blushDeep,
      },
      text: {
        primary: CHERRY_DEV.ink,
        secondary: CHERRY_DEV.inkMuted,
      },
      warning: {
        main: '#E65100',
      },
      success: {
        main: CHERRY_DEV.leaf,
      },
    },
    typography: {
      fontFamily:
        '"Outfit", "Segoe UI", system-ui, -apple-system, BlinkMacSystemFont, sans-serif',
      h1: { fontWeight: 800, letterSpacing: '-0.03em' },
      h2: { fontWeight: 700, letterSpacing: '-0.02em' },
      h3: { fontWeight: 700 },
      h4: { fontWeight: 800 },
      h5: { fontWeight: 700 },
      h6: { fontWeight: 700 },
      button: { fontWeight: 700, textTransform: 'none' },
    },
    shape: { borderRadius: 14 },
  });
}

export function CherryDevTheme({ children }) {
  const base = useTheme();
  const theme = useMemo(() => buildCherryDevTheme(base), [base]);
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}

CherryDevTheme.propTypes = {
  children: PropTypes.node.isRequired,
};
